/*
 * Jira Ticket:
 * Created Date: Fri, 17th Jan 2020, 16:14:54 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

export default ({ type, resource, result }) => {
  // override results returned from backend here, e.g. create required field names
  if (resource === 'Subcontract' && type === 'GET_ONE') {
    if (result.data.projects && result.data.projects.length > 0) {
      result.data.projectIds = result.data.projects.map(project => project.id);
    }
  }
  if (resource === 'Employment' && type === 'GET_ONE') {
    if (result.data.projects && result.data.projects.length > 0) {
      result.data.projectIds = result.data.projects.map(project => project.id);
    }
  }
  if (resource === 'Site' && (type === 'GET_ONE' || type === 'UPDATE')) {
    if (result.data.project && result.data.project.id) {
      result.data.projectId = result.data.project.id;
    }
  }
  return result;
};
